/* RESPONSIBLE TEAM: team-self-serve */

import Service, { inject as service } from '@ember/service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type AppService from 'embercom/services/app-service';

export default class EssentialDowngradeWarningModalService extends Service {
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare appService: AppService;

  get hasLiveWorkflows() {
    return this.aiAgentSetupService.totalLiveWorkflowsCount > 0;
  }

  get hasPausedWorkflows() {
    return this.aiAgentSetupService.totalPausedWorkflowsCount > 0;
  }

  get hasAnyFinWorkflows() {
    return (
      this.aiAgentSetupService.finStats.workflowsCount.liveFinWorkflowsCount > 0 ||
      this.aiAgentSetupService.totalPausedFinWorkflowsCount > 0
    );
  }

  get numberOfWorkflows() {
    if (this.hasLiveWorkflows) {
      return this.aiAgentSetupService.totalLiveWorkflowsCount;
    }
    return this.aiAgentSetupService.totalPausedWorkflowsCount;
  }

  get workflowPauseVariant(): 'will_be_paused' | 'will_remain_paused' {
    return this.hasLiveWorkflows ? 'will_be_paused' : 'will_remain_paused';
  }

  get liteSeatCount() {
    return this.appService.app.humanAdminsWithLiteSeat.length;
  }

  get pauseWorkflowsWarningProps() {
    if (!this.hasLiveWorkflows && !this.hasPausedWorkflows) {
      return undefined;
    }

    return {
      numberOfWorkflows: this.numberOfWorkflows,
      hasFinWorkflows: this.hasAnyFinWorkflows,
      workflowPauseVariant: this.workflowPauseVariant,
    };
  }

  get shouldShowWarning() {
    return (
      this.appService.app.canSeeEssentialDowngradeWarnings &&
      (this.liteSeatCount > 0 || this.hasLiveWorkflows || this.hasPausedWorkflows)
    );
  }

  loadEvaluationCriteria() {
    this.aiAgentSetupService.reloadWorkflowsCounts();
  }
}

declare module '@ember/service' {
  interface Registry {
    essentialDowngradeWarningModalService: EssentialDowngradeWarningModalService;
    'essential-downgrade-warning-modal-service': EssentialDowngradeWarningModalService;
  }
}
